<template>
  <a
    :href="`#${item.id}`"
    class="event-full-nav-anchor"
    :class="{ 'is-active': isActive, 'is-current': isCurrent }"
    :style="`width: ${size}px`"
  >
    <div class="event-full-nav-anchor-label">
      {{ item.label }}
    </div>
  </a>
</template>

<script>
export default {
  props: {
    item: Object,
    size: Number,
    isActive: Boolean,
    isCurrent: Boolean
  }
}
</script>

<style lang="scss">
.event-full-nav-anchor {
  display: block;
  position: relative;
  width: 20px;
  padding: 4px 0 4px 45px;
  cursor: pointer;
  transition: width 0.2s linear;

  &::before {
    content: '';
    display: block;
    width: 100%;
    height: 3px;
    background: rgba(#fff, 0.45);
    transition: background 0.2s;
  }

  &.is-active::before {
    background: lightgreen;
  }

  &.is-current::before {
    background: lightgreen;
  }
}

.event-full-nav-anchor-label {
  position: absolute;
  top: 50%;
  left: 100%;
  transform: translateY(-50%);
  color: black;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.2s;
}

.event-full-nav-anchor.is-active .event-full-nav-anchor-label {
  opacity: 1;
}
</style>
